import React from "react";

function Footer() {
  return <div className="footer">&copy; 2022 Nakul Jhunjhunwala</div>;
}

export default Footer;
